import {IconProps} from '../icon-props-interface';
import '../icons.scss';

export const IconCircleRestocked = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
       <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
            >
            <path
                fill={color}
                d="M11 11.777H8.076v2.965H6.91v-2.965H4v-1.056h2.91V7.742h1.166v2.979H11v1.056zM13 7.026V5.742h2v9h-1.106V7.026H13z"
            ></path>
        </svg>
    </div>
);

export default IconCircleRestocked;
